import React from 'react';
import styled from 'styled-components';

import Logo from './Logo';

const Root = styled.div`
  width: 100%;
  height: 206px;
  background-color: #fafafa;
`;

const Div = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  background: linear-gradient(
    355.48deg,
    #2196f3 0%,
    rgba(33, 150, 243, 0) 49.09%
  );
`;

function index() {
  return (
    <Root>
      <Div>
        <Logo />
      </Div>
    </Root>
  );
}

export default index;
